import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminUsers_idResend_verification_email = z.any()
export type TagsPostAdminUsers_idResend_verification_email = z.infer<typeof tagsPostAdminUsers_idResend_verification_email>

export const paramsPostAdminUsers_idResend_verification_email = z.object({ "id": z.string() })
export type ParamsPostAdminUsers_idResend_verification_email = z.infer<typeof paramsPostAdminUsers_idResend_verification_email>

export const responsePostAdminUsers_idResend_verification_email = z.any()
export type ResponsePostAdminUsers_idResend_verification_email = z.infer<typeof responsePostAdminUsers_idResend_verification_email>

interface IPostAdminUsers_idResend_verification_email extends BaseMethodType {
  tags: TagsPostAdminUsers_idResend_verification_email,
  params: ParamsPostAdminUsers_idResend_verification_email,
  response: ResponsePostAdminUsers_idResend_verification_email
}
export const URL = '/admin/users/:id/resend-verification-email'
export const validation = {
  post: {
    tags: tagsPostAdminUsers_idResend_verification_email,
    params: paramsPostAdminUsers_idResend_verification_email,
    response: responsePostAdminUsers_idResend_verification_email
  }
}
export interface AdminUsers_idResend_verification_email extends BaseRouteType {
  post: IPostAdminUsers_idResend_verification_email
}